<template>
      <div class="grid grid-cols-12 bg-white rounded-lg border border-gray-100 my-2 p-4 dark:bg-slate-900 dark:border-gray-700">
        <div v-if="technologias.length > 1" class="p-2 md:col-span-6 col-span-12">
          <SelectDefault
            v-model="cittId" :options="technologias"
            label="Servicios disponibles para diligenciar odontología"
            :map-options="(item: ICitaTechnologiasSalud) => { return { optionText: item.cittTechnologia, optionValue: item.cittId } }"
          />
        </div>
        
        <template
        v-for="odontogramaItem in odontogramas"
        :key="odontogramaItem.coodId"
        >
          <div
          v-if="cittId"
          :id="'odont_' + odontogramaItem.coodId + '_' + cittId"
            class="odontograma col-span-12 grid grid-cols-1 my-10"
            >
            <div class=" overflow-x-auto">
              <OdontogramaCanvasForm
              :key="cittId"
              :is-view="false"
              :odontograma="odontogramaItem"
              :ciad-id="ciadId"
              :citt-id="cittId"
              :set-datos-odontologia="setDatosOdontologia"
              :comp="comp"/>
            </div>
          </div>
        </template>
      </div>
</template>
<script setup lang="ts">
import { ref, /* inject, */ onMounted } from 'vue'
import type { ICitaTechnologiasSalud } from '@/modules/Asistencial/interfaces'
import { odontogramaService } from '@/services'
import { useOdontograma } from '@/modules/Asistencial/composables/useOdontograma'
import type { IFormComponent } from '@/modules/Administracion/interfaces'
import OdontogramaCanvasForm from './OdontogramaCanvasForm.vue'

const cittId = ref<number | null>(null)
const props = defineProps<{
  ciadId: number
  technologias: ICitaTechnologiasSalud[]
  odontograma: string
  comp: IFormComponent
  tipo: string
}>()
const { odontogramas, setDatosOdontologia } = useOdontograma(props.tipo)

onMounted(async () => {
  const { data } = await odontogramaService.list({ coodNombre: props.odontograma })
  odontogramas.value = data.body
  if(props.technologias && props.technologias?.length > 0) {
    cittId.value = props.technologias[0].cittId as number
  }
})

</script>
<style scoped>
.odontograma :deep(.canvas) {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.odontograma :deep(svg) {
  transition: all .2s;
}

.odontograma :deep(.marcacionSeleccionada) {
  transform: scale(1.1);
}

.odontograma :deep(.marcacionSeleccionada>*) {
  opacity: 1;
}

.odontograma :deep(svg:not(.nohover)>*) {
  cursor: pointer;
}

.odontograma :deep(path),
.odontograma :deep(rect) {
  opacity: .6;
  transition: all .2s;
}

.odontograma :deep(path:hover),
.odontograma :deep(rect:hover) {
  opacity: 1;
  transform: scale(1.02);
}
</style>
